// ============================================================
// DamageAfterDefenceChart - Post-defence damage histogram.
// ============================================================
import BarChart from './BarChart';
import type { DamageAfterDefence } from '../../engine/defenceProbability';

interface Props {
  data: DamageAfterDefence;
}

export default function DamageAfterDefenceChart({ data }: Props) {
  const bars = data.bins.map((bin) => ({
    label: bin.min === bin.max ? String(bin.min) : `${bin.min}-${bin.max}`,
    value: bin.probability,
  }));

  const maxProb = Math.max(...data.bins.map((b) => b.probability), 0.01);

  return (
    <BarChart
      data={bars}
      barColor="#a78bfa"
      showValues
      formatValue={(v) => (v * 100).toFixed(0) + '%'}
      maxValue={Math.max(maxProb * 1.2, 0.01)}
    />
  );
}
